import type { ReportTypeId } from '../../config/reportTypes';

/** These location-screening families can describe gaps without a solved design. */
export function allowsScreeningWithSourceGaps(type: ReportTypeId | undefined): boolean {
  return type === 'feasibility' || type === 'environmental' || type === 'public-sentiment';
}
